import { Component, Inject, Input }              from '@angular/core';

@Component({
  selector      : 'bread-crumb',
  templateUrl   : 'BreadCrumb.html',
})
export class BreadCrumb extends Component {


}